<template>
  <div
    class="vqb-group"
    :class="classObject"
  >
    <div
      class="vqb-group-heading"
      :class="{ 'panel-heading': styled }"
    >
      <div
        class="match-type-container"
        :class="{ 'form-inline': styled }"
      >
        <div :class="{ 'form-group': styled }">
          <label> {{ labels.notOperator }} </label>
        </div>
        <button
          v-if="this.depth > 1"
          type="button"
          :class="{ 'close pull-right': styled }"
          @click="remove"
          v-safe-html="labels.removeGroup"
        />
      </div>
    </div>

    <div
      class="vqb-group-body"
      :class="{ 'panel-body': styled }"
    >
      <div class="children">
        <!-- Either a query-builder-group or a query-builder-rule
             That is why all properties must be loaded, we don't know before hand if it is a group or a rule.
        -->
        <query-builder-group
          :index="0"
          :query.sync="query.value.query"
          :rule-types="ruleTypes"
          :rules="rules"
          :max-depth="maxDepth"
          :depth="depth + 1"
          :styled="styled"
          :labels="labels"
          :program-id="programId"
          :show-only="showOnly"
          type="query-builder-group"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from './utilities.js'

export default {
  name: 'QueryBuilderNot',

  props: ['ruleTypes', 'type', 'query', 'rules', 'index', 'showOnly', 'maxDepth', 'depth', 'styled', 'labels', 'programId'],

  computed: {
    classObject () {
      var classObject = {
        'panel ': this.styled,
      }

      classObject['depth-' + this.depth.toString()] = this.styled

      return classObject
    },
  },

  beforeCreate: function () {
    this.$options.components.QueryBuilderGroup = require('./QueryBuilderGroup.vue').default
  },

  methods: {

    remove () {
      this.$emit('child-deletion-requested', this.index)
    },
  },
}
</script>
